import * as React from 'react';
import { cn } from '@/utils/utils';
import { Card } from '@/components/ui/card';

interface NoticeCardProps {
  title: React.ReactNode;
  /** What happened and what it means for the user's work. */
  children?: React.ReactNode;
  /** A smaller line: what they can do about it. */
  hint?: React.ReactNode;
  /** Buttons under the text. */
  actions?: React.ReactNode;
  className?: string;
}

/** A card that explains why the user can't carry on (offline, Lureo unavailable), centred on the page or a scrim. */
export function NoticeCard({ title, children, hint, actions, className }: NoticeCardProps) {
  return (
    <Card padding="lg" className={cn('flex w-[min(24rem,calc(100vw-2rem))] flex-col items-center gap-3 text-center font-lureo-font-ui', className)}>
      <h2 className="text-lureo-16 font-semibold leading-[1.3] text-lureo-ink">{title}</h2>
      {children && <p className="font-lureo-font-prose text-lureo-13 leading-[1.45] text-lureo-ink-subtle">{children}</p>}
      {hint && <p className="font-lureo-font-prose text-lureo-12 text-lureo-ink-subtlest">{hint}</p>}
      {actions && <div className="mt-1 flex flex-wrap justify-center gap-3">{actions}</div>}
    </Card>
  );
}
